import { parseToRgb, rgb } from 'polished';
export function getDefaultFeatureColor(dt, gt) {
    if (dt.enableNovaTokens) {
        const pinColor = gt.tokens['geospatial-pin-color'];
        return rgb(parseToRgb(pinColor)); // convert hsl to rgb for ColorPicker
    }
    switch (dt.themeVariant) {
        case 'high-contrast':
        case 'dark':
            // Use true white because dt.c.white maps to neutral but ObjectSearch features do not
            return '#fff';
        default:
            return dt.c.black;
    }
}
export function getFeatureTokens(dt, gt, feature) {
    var _a;
    return {
        fg: (_a = feature.color) !== null && _a !== void 0 ? _a : getDefaultFeatureColor(dt, gt),
    };
}
/**
 * High contrast selection inverts colors. These styles invert colors again so
 * elements display in their original color.
 */
export function preventColorInversionStyles(item, color) {
    return item.selected && color !== null ? { filter: 'var(--table-selected-internal-filter)' } : {};
}
